import { gql, graphql } from "react-apollo"
import { createKioskInput } from "../helpers"
import { GetKiosksQuery } from "./withKiosks"
import type { Kiosk } from "../types"

const MUTATE_CREATE_KIOSK = gql`
  mutation CreateKiosk($kiosk: KioskInput!) {
    createKiosk(kiosk: $kiosk) {
      id
      friendlyName
      shortName
      email
      language
      hidden
      latitude
      longitude
      usesVirtualKeyboard
      primarySensor {
        id
      }
      startsAt
      endsAt
    }
  }
`

const mutateCreateKiosk = graphql(MUTATE_CREATE_KIOSK, {
  name: "mutateCreateKiosk",
  options: {
    refetchQueries: [{ query: GetKiosksQuery, variables: { query: "" } }]
  },
  props: ({ mutateCreateKiosk }) => ({
    createKiosk: (kiosk: Kiosk) =>
      mutateCreateKiosk({ variables: { kiosk: createKioskInput(kiosk) } })
  })
})

export default mutateCreateKiosk



// WEBPACK FOOTER //
// ./src/Kiosks/queries/mutateCreateKiosk.js